import { UserData } from "../components/onBoardingv2/Register";
import { AuthApiBaseUrl } from "./baseUrls";
import { fetchWrapper } from "@gogig-in/gogig-clients";

export async function addUserData(userData: UserData, authHeader: string) {
    return await fetchWrapper(`${AuthApiBaseUrl}/updateUser`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: authHeader,
      },
      body: userData,
    });
  }